(function (window) {
  'use strict';

  function callClarity(method, key, value) {
    if (!window || typeof window.clarity !== 'function') return;
    try {
      if (arguments.length >= 3) {
        window.clarity(method, key, value);
        return;
      }
      window.clarity(method, key);
    } catch (error) {}
  }

  function trackEvent(name) {
    if (!name) return;
    callClarity('event', name);
  }

  function setValue(key, value) {
    if (!key || value === undefined || value === null) return;
    callClarity('set', key, value);
  }

  function getChannelType(resultKind) {
    var normalizedKind = String(resultKind || '').trim();
    if (normalizedKind === 'ambassador') return 'ambassador';
    if (normalizedKind === 'workshop') return 'strutt_workshop';
    if (normalizedKind === 'dealer') return 'dealer';
    if (normalizedKind === 'dealer_workshop') return 'dealer_workshop';
    return '';
  }

  function getLeadOnlyType(item) {
    var fallbackMode = String(item && item.fallbackMode || '').trim();
    return fallbackMode === 'empty' ? 'lead_only_none_res' : 'lead_only_has_res';
  }

  function getAvailableChannelTypes(items) {
    var resultItems = Array.isArray(items) ? items : [];
    if (!resultItems.length) return ['lead_only_none_res'];
    var seenTypes = {};
    var channelTypes = resultItems.map(function (item) {
      return getChannelType(item && item.resultKind);
    }).filter(function (type) {
      if (!type || seenTypes[type]) return false;
      seenTypes[type] = true;
      return true;
    });
    channelTypes.push('lead_only_has_res');
    return channelTypes;
  }

  function getBookingType(item, hasAmbassadorSelection, isFallbackResultFn) {
    if (hasAmbassadorSelection) return 'ambassador';
    if (!item) return '';
    if (typeof isFallbackResultFn === 'function' && isFallbackResultFn(item)) {
      return getLeadOnlyType(item);
    }
    return getChannelType(item.resultKind);
  }

  function trackLandingPageView(state) {
    if (state && state.landingPageViewed) return;
    if (state) state.landingPageViewed = true;
    trackEvent('view_take_drive_lp');
  }

  function trackTakeDriveCtaClick() {
    trackEvent('click_take_drive_cta');
  }

  function trackFirstStepSearchSubmit(options) {
    var country = String(options && options.country || '').trim();
    var newsletterSubscribed = !!(options && options.newsletterSubscribed);
    setValue('country', country);
    setValue('newsletter', newsletterSubscribed ? 'subscribed' : 'not_subscribed');
    trackEvent('submit_test_drive_search');
  }

  function trackBookingPageView(state) {
    if (state && state.bookingPageViewed) return;
    if (state) state.bookingPageViewed = true;
    trackEvent('view_booking_page');
  }

  function trackSearchResultsView(items) {
    var resultItems = Array.isArray(items) ? items : [];
    setValue('search_result_count', String(resultItems.length));
    setValue('available_channel_types', getAvailableChannelTypes(resultItems));
    trackEvent('view_test_drive_results');
  }

  function trackBookingFormStart(state) {
    if (state && state.bookingFormStarted) return;
    if (state) state.bookingFormStarted = true;
    trackEvent('start_booking_form');
  }

  function trackBookingSubmit(bookingType) {
    if (bookingType) {
      setValue('booking_type', bookingType);
    }
    trackEvent('submit_booking');
  }

  function trackBookingSuccess() {
    trackEvent('booking_success');
  }

  function trackWaiverView() {
    trackEvent('view_waiver');
  }

  function trackCommunityPopupView() {
    trackEvent('community_popup_view');
  }

  function trackCommunityJoinNow() {
    trackEvent('community_join_now');
  }

  function trackCommunityDeclineButton() {
    trackEvent('community_decline_button');
  }

  function trackCommunityCloseIcon() {
    trackEvent('community_close_icon');
  }

  function handleSuccessModalCloseAction(button, onClose) {
    var action = String(button && button.getAttribute('data-clarity-community-action') || '').trim();
    if (action === 'decline_button') {
      trackCommunityDeclineButton();
    } else if (action === 'close_icon') {
      trackCommunityCloseIcon();
    }
    if (typeof onClose === 'function') {
      onClose({ redirect: true });
    }
  }

  function handleSuccessModalJoinNow(onOpenCommunity, onClose) {
    trackCommunityJoinNow();
    if (typeof onOpenCommunity === 'function') {
      onOpenCommunity();
    }
    if (typeof onClose === 'function') {
      onClose({ redirect: true });
    }
  }

  function handleSuccessModalEscape(event, successModal, onClose) {
    if (!event || event.key !== 'Escape' || !successModal || successModal.hidden) return;
    if (typeof onClose === 'function') {
      onClose({ redirect: true });
    }
  }

  function getPathwayClarityEvent(modalStyle) {
    var normalizedStyle = String(modalStyle || '').trim();
    if (normalizedStyle === 'ambassador') return 'expand_ambassador_intro';
    if (normalizedStyle === 'workshop') return 'expand_strutt_workshop_intro';
    if (normalizedStyle === 'dealer') return 'expand_dealer_intro';
    return '';
  }

  function trackPathwayIntro(modalStyle) {
    trackEvent(getPathwayClarityEvent(modalStyle));
  }

  window.TakeDriveClarity = {
    getBookingType: getBookingType,
    trackLandingPageView: trackLandingPageView,
    trackTakeDriveCtaClick: trackTakeDriveCtaClick,
    trackFirstStepSearchSubmit: trackFirstStepSearchSubmit,
    trackBookingPageView: trackBookingPageView,
    trackSearchResultsView: trackSearchResultsView,
    trackBookingFormStart: trackBookingFormStart,
    trackBookingSubmit: trackBookingSubmit,
    trackBookingSuccess: trackBookingSuccess,
    trackWaiverView: trackWaiverView,
    trackCommunityPopupView: trackCommunityPopupView,
    handleSuccessModalCloseAction: handleSuccessModalCloseAction,
    handleSuccessModalJoinNow: handleSuccessModalJoinNow,
    handleSuccessModalEscape: handleSuccessModalEscape,
    trackPathwayIntro: trackPathwayIntro
  };
}(window));
